"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsPrepaidBillingFilter = void 0;
class IsPrepaidBillingFilter {
    static transform(billingStatus) {
        return !!(billingStatus && billingStatus.billingType === 'PREPAID');
    }
}
exports.IsPrepaidBillingFilter = IsPrepaidBillingFilter;
angular.module('callX').filter('isPrepaidBilling', () => IsPrepaidBillingFilter.transform);
